window.lightbox = require('lightbox2');
